// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

Vue.config.productionTip = false
Vue.use(ElementUI)
const i18n = new VueI18n({
  locale:localStorage.getItem('languageSet') || 'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages:{
    'zh': require('./components/language/zh'),
    'en': require('./components/language/en')
  }
})

Vue.prototype.ISMOBILE = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  data: function () {
    return {
      isBackstage: false
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js